import { defineTopic } from 'magpie-lib/models';
import { assistantPublishMessage, assistantTopicFilter } from '../messages/assistantPublishMesage';
const ASSISTANT_TOPIC = 'ASSISTANT_TOPIC';
export const AssistantTopicDef = defineTopic({
  name: ASSISTANT_TOPIC,
  messages: [assistantPublishMessage],
  enableRuntimeValidation: false,
  audience: assistantTopicFilter
});